// extracted by mini-css-extract-plugin
export default {"ModalBackdrop":"ModalBackdrop-styles__ModalBackdrop__RgTMM"};